module.exports = __webpack_public_path__ + "media/icons/skrzynia-manualna-white@2x-6dd9e97a.png";